<template>
  <div class="message-board-page">
    <div class="shell">
      <div class="shell-inner">
        <div class="canvas" :style="canvasStyle">
          <div class="breadcrumb">
            <img :src="assets.breadcrumbIcon" alt="首页" class="breadcrumb-icon" />
            <span class="breadcrumb-text">首页 &gt; 客户留言板</span>
          </div>

          <div class="header">
            <button type="button" class="back" @click="goHome">
              <img :src="assets.backIcon" alt="" class="back-icon" />
              <span class="back-text">返回首页</span>
            </button>
            <h1 class="title">客户留言板</h1>
          </div>

          <div class="form-panel">
            <label class="form-row form-row-offset">
              <span class="form-label">联系人</span>
              <input v-model.trim="form.contactName" type="text" class="input" placeholder="请输入联系人姓名" />
            </label>

            <label class="form-row">
              <span class="form-label">联系方式</span>
              <input v-model.trim="form.contactPhone" type="text" class="input" placeholder="请输入联系方式" />
            </label>

            <label class="form-row form-row-textarea">
              <span class="form-label form-label-textarea"> 留言内容 </span>
              <textarea v-model.trim="form.message" class="textarea" placeholder="请输入留言内容" />
            </label>
          </div>

          <button type="button" class="submit" @click="handleSubmitMessage">
            {{ submitting ? "提交中..." : "提交" }}
          </button>

          <img :src="assets.divider" alt="" class="divider" />

          <h2 class="list-title">我的留言（{{ messages.length }}）</h2>

          <div v-for="(item, index) in messages" :key="item.id" class="message-block">
            <p :class="['message-content', index === 0 && 'message-content-first']">
              {{ item.content }}
            </p>

            <div :class="[
              'message-meta',
              index === 0 ? 'message-meta-first' : 'message-meta-rest',
            ]">
              <span class="meta-name">{{ item.author }}</span>
              <span class="meta-phone">{{ item.phone }}</span>
              <span class="meta-time">{{ item.createdAt }}</span>
            </div>

            <div :class="[
              'reply-card',
              index === 0 ? 'reply-card-first' : 'reply-card-rest',
            ]">
              <img :src="assets.replyAvatar" alt="平台留言" class="reply-avatar" />
              <div class="reply-body">
                <div class="reply-content-wrap">
                  <p class="reply-content">
                    <span class="reply-prefix">平台留言：</span>
                    {{ item.reply.content }}
                  </p>
                </div>
                <p class="reply-time">
                  {{ item.reply.createdAt }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isLoggedIn } from "@/util/token-util.js";
import bus from "@/util/bus.js";

const PAGE_CANVAS_WIDTH = 1920;

const createEmptyForm = () => ({
  contactName: "",
  contactPhone: "",
  message: "",
});

function normalizeReply(item) {
  return {
    createdAt: item.reply_at || "",
    content: item.reply_content || "暂无平台回复",
  };
}

function normalizeMessageItem(item) {
  return {
    id: String(item.id || Date.now()),
    content: item.content || "",
    author: item.name || item.author || "",
    phone: item.phone || "",
    createdAt: item.created_at || "",
    reply: normalizeReply(item),
  };
}

export default {
  name: "MessageBoardPage",
  created() {
    this.fetchMessages();
  },
  data() {
    return {
      assets: {
        breadcrumbIcon: require("../../assets/message-board/breadcrumb-icon.svg"),
        backIcon: require("../../assets/message-board/back-icon.svg"),
        divider: require("../../assets/message-board/divider.svg"),
        replyAvatar: require("../../assets/message-board/reply-avatar.png"),
      },
      form: createEmptyForm(),
      pageScale: 1,
      submitting: false,
      messages: [],
    };
  },
  computed: {
    canvasStyle() {
      return {
        zoom: this.pageScale,
      };
    },
  },
  mounted() {
    this.toggleViewportClass(true);
    this.updatePageScale();
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.toggleViewportClass(false);
  },
  methods: {
    toggleViewportClass(shouldAdd) {
      const action = shouldAdd ? "add" : "remove";

      document.documentElement.classList[action]("page-scale-fit");
      document.body.classList[action]("page-scale-fit");
    },
    handleWindowResize() {
      this.updatePageScale();
    },
    updatePageScale() {
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const nextScale = viewportWidth / PAGE_CANVAS_WIDTH;

      if (nextScale > 0 && nextScale !== this.pageScale) {
        this.pageScale = nextScale;
      }
    },
    ensureLoggedIn() {
      if (isLoggedIn()) {
        return true;
      }

      bus.$emit("openLoginDialog", "请登录后再查看或提交留言");
      return false;
    },
    goHome() {
      this.$router.push("/");
    },
    async fetchMessages() {
      if (!isLoggedIn()) {
        this.messages = [];
        bus.$emit("openLoginDialog", "请登录后再查看留言");
        return;
      }

      try {
        const res = await this.$api({
          url: "Feedback/myMessageBoard",
          method: "get",
          data: {
            page_num: 10,
          },
        });

        if (res.code === 200 && res.data && Array.isArray(res.data.list)) {
          this.messages = res.data.list.map(normalizeMessageItem);
        }
      } catch (error) {
        console.log("fetchMessages error", error);
      }
    },
    async handleSubmitMessage() {
      if (
        !this.form.contactName ||
        !this.form.contactPhone ||
        !this.form.message
      ) {
        this.$message.warning("请先完整填写留言信息");
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.contactPhone)) {
        this.$message.warning("请输入正确的手机号码");
        return;
      }

      if (!this.ensureLoggedIn()) {
        return;
      }

      this.submitting = true;

      try {
        const res = await this.$api({
          url: "Feedback/messageBoard",
          method: "post",
          data: {
            name: this.form.contactName,
            phone: this.form.contactPhone,
            content: this.form.message,
          },
        });

        if (res.code === 200) {
          this.$message.success(res.msg || "留言提交成功");
          this.form = createEmptyForm();
          this.fetchMessages();
          return;
        }

        this.$message.error(res.msg || "留言提交失败");
      } catch (error) {
        this.$message.error("留言提交失败，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.message-board-page {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
}

.shell {
  width: 100%;
}

.shell-inner {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.canvas {
  flex: 0 0 auto;
  width: 1920px;
  padding-bottom: 89px;
  overflow: hidden;
  transform-origin: top left;
}

.breadcrumb {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  align-self: stretch;
  min-width: 1920px;
  height: 40px;
  padding: 0 11px;
  background: #f7f7f7;
}

.breadcrumb-icon {
  display: block;
  flex: 0 0 auto;
  width: 14px;
  height: 13px;
}

.breadcrumb-text {
  flex: 0 0 auto;
  color: #666666;
  font-size: 14px;
  line-height: 20px;
}

.header {
  position: relative;
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  margin-top: 19px;
  padding: 0 35px;
}

.back {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d92f24;
  border-radius: 4px;
  padding: 10px 14px 9px 13px;
  width: 118px;
  min-width: 118px;
  height: 43px;
  background: #ffffff;
  cursor: pointer;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.back-text {
  color: #d92f24;
  font-size: 16px;
  line-height: 22px;
}

.title {
  position: absolute;
  top: 11px;
  left: 50%;
  margin: 0;
  transform: translateX(-50%);
  overflow: hidden;
  color: #000000;
  font-size: 36px;
  font-weight: 700;
  line-height: 43px;
  white-space: nowrap;
}

.form-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  margin: 29px 366px 0 363px;
  overflow: hidden;
}

.form-row {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  justify-content: space-between;
}

.form-row-offset {
  padding-left: 15px;
}

.form-row+.form-row {
  margin-top: 29px;
}

.form-label {
  margin: 10px 0 0;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
}

.form-label-textarea {
  margin-top: 12px;
}

.input,
.textarea {
  box-sizing: border-box;
  border: 1px solid #d4d4d4;
  border-radius: 8px;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
  outline: none;
}

.input {
  width: 1050px;
  height: 44px;
  padding: 9px 22px 11px 21px;
}

.textarea {
  width: 1050px;
  height: 114px;
  padding: 11px 22px 81px 22px;
  resize: none;
}

.input::placeholder,
.textarea::placeholder {
  color: #666666;
}

.submit {
  position: relative;
  margin-top: 21px;
  margin-left: 445px;
  border: 0;
  border-radius: 8px;
  width: 131px;
  height: 44px;
  background: #d92f24;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.divider {
  width: 1922px;
  height: 1px;
  margin-top: 29px;
  margin-left: -1px;
}

.list-title {
  margin: 31px 0 0 260px;
  color: #333333;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
}

.message-block {
  width: 100%;
}

.message-content {
  margin: 37px 0 0 260px;
  color: #333333;
  font-size: 16px;
  line-height: 22px;
}

.message-content-first {
  margin-top: 30px;
  max-width: 1120px;
}

.message-meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 27px;
  padding-left: 260px;
}

.message-meta-first {
  margin-top: 16px;
}

.message-meta-rest {
  margin-top: 9px;
}

.meta-name,
.meta-phone,
.meta-time {
  color: #333333;
  font-size: 16px;
}

.meta-name,
.meta-phone {
  font-weight: 700;
  line-height: 19px;
}

.meta-phone {
  margin-left: 0;
}

.meta-time {
  margin-left: 15px;
  line-height: 22px;
}

.reply-card {
  display: flex;
  align-items: flex-start;
  margin: 28px 260px 0;
  border-radius: 8px;
  background: #f1f1f1;
  padding: 19px 22px 19px 21px;
}

.reply-card-rest {
  margin-top: 27px;
}

.reply-avatar {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
}

.reply-body {
  flex: 1;
  min-width: 0;
  margin-left: 21px;
}

.reply-content-wrap {
  width: 100%;
}

.reply-content {
  margin: 0;
  color: #333333;
  font-size: 16px;
  line-height: 22px;
  white-space: normal;
  word-break: break-all;
  text-indent: 2em;
}

.reply-prefix {
  font-weight: 700;
}

.reply-time {
  margin: 18px 0 0;
  color: #666666;
  font-size: 14px;
  line-height: 20px;
}
</style>
